/**
 * Intertaal custom storefront helpers.
 * Core Warehouse cart, variant and navigation behaviour remains untouched.
 */

(function () {
  function upgradeHomeHeroChips() {
    var chipWrap = document.querySelector('.intertaal-home-hero__chips');
    if (!chipWrap || chipWrap.dataset.linksReady === 'true') return;

    var chips = chipWrap.querySelectorAll('span');
    var destinations = [
      '/collections/all?sort_by=created-descending',
      '/collections/special-editions',
      '/collections/study-professional'
    ];
    var labels = [
      'Nieuw in de shop',
      'Special editions',
      'Studie & vakliteratuur'
    ];

    chips.forEach(function (chip, index) {
      if (!destinations[index]) return;
      var link = document.createElement('a');
      link.href = destinations[index];
      link.className = 'intertaal-home-hero__chip-link';
      link.textContent = labels[index] || chip.textContent.trim();
      link.setAttribute('aria-label', labels[index] || chip.textContent.trim());
      chip.replaceWith(link);
    });

    chipWrap.dataset.linksReady = 'true';
  }

  var publisherInfo = {
    'cornelsen-verlag': ['Cornelsen Verlag', 'Duitse taalmethodes en leermiddelen voor school, studie en volwassenenonderwijs.'],
    'delta-business-communication-skills': ['DELTA Publishing', 'Praktisch taalonderwijs, business communication en professionele vaardigheden.'],
    'klett-sprachen': ['Klett Sprachen', 'Moderne taalmethodes en leermiddelen voor Duits en andere talen.'],
    'alma-edizioni-taalmethodes-voor-italiaans-leren': ['ALMA Edizioni', 'Italiaans leren met authentieke, communicatieve methodes uit Italië.'],
    'helbling-languages-innovatieve-taalmethode-uitgever-met-visie': ['Helbling Languages', 'Taalonderwijs met sterke didactiek, actuele inhoud en internationale expertise.'],
    'cideb-blackcat': ['Black Cat · CIDEB', 'Taalmethodes, graded readers en aanvullend materiaal voor moderne talen.'],
    'penguin-engelse-klassiekers-en-literatuur-van-books': ['Penguin Random House', 'Engelse literatuur, klassiekers, fictie en internationale bestsellers.'],
    'cambridge-up': ['Cambridge University Press', 'English, education en academische titels van een wereldwijde kennisuitgever.'],
    'oxford-university-press': ['Oxford University Press', 'Taalonderwijs, studieboeken en academische vakliteratuur.'],
    'pearson-english-effectief-engels-leren-voor-elk-niveau': ['Pearson English', 'Engels leren en studeren met internationaal gebruikte methodes en vakboeken.'],
    'sgel-ele-spaans-leren-met-topmethodes-uit-spanje-sgel': ['SGEL', 'Spaanse taalmethodes en ELE-materiaal rechtstreeks uit Spanje.'],
    'national-geographic-learning-engels-leren-met-impact': ['National Geographic Learning', 'Engels leren met echte verhalen, wetenschap en de wereld als inspiratie.']
  };

  function ensurePublisherSearchStyles() {
    if (document.getElementById('intertaal-publisher-search-styles')) return;

    var style = document.createElement('style');
    style.id = 'intertaal-publisher-search-styles';
    style.textContent = [
      '.intertaal-publisher-search{width:min(760px,100%);margin:4px auto 30px}',
      '.intertaal-publisher-search__field{display:flex;align-items:center;gap:12px;height:54px;padding:0 15px;border:1px solid rgba(37,33,35,.12);border-radius:14px;background:#fff;box-shadow:0 6px 20px rgba(37,33,35,.055);transition:border-color .18s ease,box-shadow .18s ease}',
      '.intertaal-publisher-search__field:focus-within{border-color:rgba(210,112,28,.62);box-shadow:0 0 0 3px rgba(210,112,28,.10),0 8px 24px rgba(37,33,35,.07)}',
      '.intertaal-publisher-search__icon{width:20px;height:20px;flex:0 0 20px;color:#d2701c}',
      '.intertaal-publisher-search__input{flex:1;min-width:0;height:100%;padding:0!important;border:0!important;outline:0!important;background:transparent!important;box-shadow:none!important;color:#252123;font:inherit;font-size:15px}',
      '.intertaal-publisher-search__input::placeholder{color:#8a8387;opacity:1}',
      '.intertaal-publisher-search__clear{flex:0 0 auto;padding:8px;border:0;background:transparent;color:#d2701c;font-size:12px;font-weight:800;cursor:pointer}',
      '.intertaal-publisher-search__clear:hover{text-decoration:underline}',
      '.intertaal-publisher-search__status{min-height:18px;margin:7px 4px 0;color:#7c7578;font-size:12px;line-height:1.4}',
      '.intertaal-publisher-search__empty{margin:24px 0 0;padding:20px;border:1px solid rgba(37,33,35,.07);border-radius:14px;background:#faf8f5;color:#6f696c;text-align:center;font-size:14px}',
      '.intertaal-publisher-directory__cell[hidden]{display:none!important}',
      '@media screen and (max-width:640px){.intertaal-publisher-search{margin:0 auto 22px}.intertaal-publisher-search__field{height:50px;border-radius:12px}.intertaal-publisher-search__input{font-size:14px}}'
    ].join('');
    document.head.appendChild(style);
  }

  function addPublisherSearch(section) {
    if (!section || section.querySelector('.intertaal-publisher-search')) return;

    var grid = section.querySelector('.collection-list__section .grid');
    if (!grid) return;

    var cells = Array.from(grid.querySelectorAll('.intertaal-publisher-directory__cell'));
    if (!cells.length) return;

    ensurePublisherSearchStyles();
    if (!grid.id) grid.id = 'intertaal-publisher-list';

    var search = document.createElement('div');
    search.className = 'intertaal-publisher-search';
    search.innerHTML = '<label class="visually-hidden" for="intertaal-publisher-search-input">Zoek een uitgever</label>' +
      '<div class="intertaal-publisher-search__field">' +
        '<svg class="intertaal-publisher-search__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><circle cx="11" cy="11" r="7"></circle><path d="m20 20-3.5-3.5"></path></svg>' +
        '<input id="intertaal-publisher-search-input" class="intertaal-publisher-search__input" type="search" autocomplete="off" spellcheck="false" placeholder="Zoek op uitgever, taal of vakgebied…" aria-controls="' + grid.id + '">' +
        '<button type="button" class="intertaal-publisher-search__clear" aria-label="Zoekopdracht wissen" hidden>Wis</button>' +
      '</div>' +
      '<p class="intertaal-publisher-search__status" aria-live="polite"></p>' +
      '<p class="intertaal-publisher-search__empty" hidden>Geen uitgevers gevonden. Probeer een andere zoekterm.</p>';

    grid.parentNode.insertBefore(search, grid);

    var input = search.querySelector('.intertaal-publisher-search__input');
    var clear = search.querySelector('.intertaal-publisher-search__clear');
    var status = search.querySelector('.intertaal-publisher-search__status');
    var empty = search.querySelector('.intertaal-publisher-search__empty');

    function normalize(value) {
      var text = String(value || '').toLowerCase();
      if (text.normalize) text = text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
      return text;
    }

    function filterPublishers() {
      var query = normalize(input.value.trim());
      var visibleCount = 0;

      cells.forEach(function (cell) {
        var card = cell.querySelector('.intertaal-publisher-directory__card');
        var searchableText = normalize((card ? card.textContent : cell.textContent) + ' ' + (card ? card.getAttribute('href') : ''));
        var isVisible = !query || searchableText.indexOf(query) !== -1;
        cell.hidden = !isVisible;
        if (isVisible) visibleCount += 1;
      });

      clear.hidden = !query;
      status.textContent = query ? visibleCount + (visibleCount === 1 ? ' uitgever gevonden' : ' uitgevers gevonden') : '';
      empty.hidden = visibleCount !== 0;
    }

    input.addEventListener('input', filterPublishers);
    input.addEventListener('search', filterPublishers);
    clear.addEventListener('click', function () {
      input.value = '';
      filterPublishers();
      input.focus();
    });
  }

  function upgradePublisherDirectory() {
    var section = document.querySelector('[data-section-type="list-collections"]');
    if (!section || section.dataset.publisherReady === 'true') return;

    var cards = section.querySelectorAll('.collection-list__section .grid .collection-block-item');
    if (!cards.length) return;

    section.classList.add('intertaal-publisher-directory');
    var header = section.querySelector('.collection-list__section .page__header');
    if (header) {
      var title = header.querySelector('.page__title');
      if (title) title.textContent = 'Kies je uitgever';

      if (!header.querySelector('.intertaal-publisher-directory__eyebrow')) {
        var eyebrow = document.createElement('p');
        eyebrow.className = 'intertaal-publisher-directory__eyebrow';
        eyebrow.textContent = 'UITGEVERS BIJ INTERTAAL';
        header.insertBefore(eyebrow, title || header.firstChild);

        var intro = document.createElement('p');
        intro.className = 'intertaal-publisher-directory__intro';
        intro.textContent = 'Vind snel de uitgever die bij jouw taal, studie of vakgebied past.';
        if (title) title.insertAdjacentElement('afterend', intro);
        else header.appendChild(intro);
      }
    }

    cards.forEach(function (card) {
      var url = new URL(card.href, window.location.origin);
      var handle = url.pathname.split('/').filter(Boolean).pop();
      var info = publisherInfo[handle] || [handle.replace(/-/g, ' '), 'Bekijk het volledige aanbod van deze uitgever.'];
      var cell = card.closest('.grid__cell');
      if (cell) cell.classList.add('intertaal-publisher-directory__cell');
      card.classList.add('intertaal-publisher-directory__card');

      var imageWrap = card.querySelector('.aspect-ratio');
      if (imageWrap) imageWrap.classList.add('intertaal-publisher-directory__logo');
      var image = card.querySelector('img');
      if (image) image.alt = info[0];

      if (!card.querySelector('.intertaal-publisher-directory__copy')) {
        var copy = document.createElement('div');
        copy.className = 'intertaal-publisher-directory__copy';
        copy.innerHTML = '<span>UITGEVER</span><h2></h2><p></p><strong>Ontdek <b aria-hidden="true">→</b></strong>';
        copy.querySelector('h2').textContent = info[0];
        copy.querySelector('p').textContent = info[1];
        card.appendChild(copy);
      }
    });

    addPublisherSearch(section);
    section.dataset.publisherReady = 'true';
  }

  function correctIntertaalRoutes() {
    var heroChips = document.querySelectorAll('.intertaal-home-hero__chip-link');
    var heroDestinations = [
      '/collections/all?sort_by=created-descending',
      '/collections/special-editions',
      '/collections/study-professional'
    ];
    var heroLabels = ['Nieuw in de shop', 'Special editions', 'Studie & vakliteratuur'];

    heroChips.forEach(function (link, index) {
      if (!heroDestinations[index]) return;
      link.href = heroDestinations[index];
      link.textContent = heroLabels[index];
      link.setAttribute('aria-label', heroLabels[index]);
    });

    var studyTopBooks = document.querySelector('.study-professional-zone__header > a');
    if (studyTopBooks && /bekijk\s+topboeken/i.test(studyTopBooks.textContent)) {
      studyTopBooks.href = '/collections/musthave-studieboeken';
    }

    var studySearch = document.querySelector('.study-search-zone');
    if (studySearch) studySearch.id = 'study-search';

    document.querySelectorAll('.collection-landing-intro').forEach(function (intro) {
      var primary = intro.querySelector('.collection-landing-intro__button--primary');
      var secondary = intro.querySelector('.collection-landing-intro__button--secondary');

      if (intro.classList.contains('collection-landing-intro--study') && primary) {
        primary.href = '#study-search';
      }

      if (intro.classList.contains('collection-landing-intro--preorder') && primary) {
        primary.href = '/collections/pre-order';
      }

      if (secondary && /bekijk\s+pre-orders/i.test(secondary.textContent)) {
        secondary.href = '/collections/pre-order';
      }
    });
  }

  function markPreorderButtons(root) {
    (root || document).querySelectorAll('button, a').forEach(function (element) {
      var label = element.textContent.replace(/\s+/g, ' ').trim().toLowerCase();
      if (/^pre[- ]?order(en)?$/.test(label)) {
        element.classList.add('intertaal-preorder-action');
      }
    });
  }

  function removeLegacyTrustStrip() {
    var labels = ['Veilig betalen', 'Klantenservice', 'Retourbeleid', 'Snelle levering'];
    var exactNodes = Array.from(document.querySelectorAll('body *')).filter(function (el) {
      return el.children.length === 0 && labels.indexOf(el.textContent.trim()) !== -1;
    });

    if (exactNodes.length < 4) return;

    var start = exactNodes.find(function (node) { return node.textContent.trim() === 'Veilig betalen'; });
    if (!start) return;

    var ancestor = start.parentElement;
    while (ancestor && ancestor !== document.body) {
      var text = ancestor.textContent || '';
      if (labels.every(function (label) { return text.indexOf(label) !== -1; })) break;
      ancestor = ancestor.parentElement;
    }

    if (!ancestor || ancestor === document.body) return;
    ancestor.classList.add('intertaal-legacy-trust');

    var previous = ancestor.previousElementSibling;
    if (previous && previous.textContent.trim() === '') {
      previous.classList.add('intertaal-heavy-separator');
    }
  }

  var trustCleanupTimer;
  function scheduleLegacyTrustCleanup() {
    window.clearTimeout(trustCleanupTimer);
    trustCleanupTimer = window.setTimeout(removeLegacyTrustStrip, 80);
  }

  function tidyHomepageExtras() {
    if (!document.body.classList.contains('template-index')) return;

    var moodTagline = document.querySelector('.booktok-zone__quick-header > span');
    if (moodTagline) moodTagline.remove();

    var nationalCard = document.querySelector('.publisher-zone__card[href*="national-geographic-learning"]');
    if (nationalCard) nationalCard.remove();
  }

  function organiseHomepageWorlds() {
    if (!document.body.classList.contains('template-index')) return;

    var booktok = document.querySelector('.booktok-zone');
    var seasonal = document.querySelector('.seasonal-zone');
    var study = document.querySelector('.study-professional-zone');
    var shelf = document.querySelector('.home-product-shelf');
    var publishers = document.querySelector('.publisher-zone');
    var greek = document.querySelector('.editorial-collection-feature');

    /* Keep Greek mythology visually with the reading world, but no extra micro-divider strip. */
    if (greek && study) {
      var greekSection = greek.closest('.shopify-section');
      var studySection = study.closest('.shopify-section');
      if (greekSection && studySection && greekSection !== studySection && greekSection.nextElementSibling !== studySection) {
        studySection.parentNode.insertBefore(greekSection, studySection);
      }
    }

    if (booktok) booktok.style.backgroundColor = '#fbf7f4';
    if (seasonal) seasonal.style.backgroundColor = '#fbf7f4';
    if (greek) greek.style.backgroundColor = '#fbf7f4';

    if (study) study.style.backgroundColor = '#f2f5f4';
    if (shelf) shelf.style.backgroundColor = '#f2f5f4';
    if (publishers) publishers.style.backgroundColor = '#f2f5f4';
  }

  function initIntertaalPolish() {
    upgradeHomeHeroChips();
    upgradePublisherDirectory();
    correctIntertaalRoutes();
    markPreorderButtons(document);
    removeLegacyTrustStrip();
    tidyHomepageExtras();
    organiseHomepageWorlds();
    scheduleLegacyTrustCleanup();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initIntertaalPolish);
  } else {
    initIntertaalPolish();
  }

  window.addEventListener('load', function () {
    window.setTimeout(removeLegacyTrustStrip, 250);
    window.setTimeout(removeLegacyTrustStrip, 900);
    window.setTimeout(tidyHomepageExtras, 120);
    window.setTimeout(correctIntertaalRoutes, 140);
  });

  document.addEventListener('variant:changed', function () {
    window.setTimeout(function () { markPreorderButtons(document); }, 30);
  });

  document.addEventListener('cart:refresh', function () {
    window.setTimeout(function () { markPreorderButtons(document); }, 60);
    scheduleLegacyTrustCleanup();
  });

  var observer = new MutationObserver(function (mutations) {
    var hasElementAddition = false;

    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) {
          markPreorderButtons(node);
          hasElementAddition = true;
        }
      });
    });

    if (hasElementAddition) {
      scheduleLegacyTrustCleanup();
      window.setTimeout(tidyHomepageExtras, 40);
      window.setTimeout(correctIntertaalRoutes, 50);
    }
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
